import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {IStore} from 'redux/interface';
import {changeLocale} from 'redux/translation/translationAsyncActions';
import {SystemLanguage} from 'utils/constants/constants';

import '../styles.scss';

export const LanguageMenu = (): JSX.Element => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const locale = useSelector((state: IStore) => state.translation.locale);
  const isEnglish = locale !== SystemLanguage.Spanish;

  function handleSelect(value: string) {
    return () => {
      if (value === locale) {
        return;
      }
      dispatch(changeLocale(value));
    };
  }

  function handleSegmentKeyDown(event: React.KeyboardEvent<HTMLButtonElement>) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
      return;
    }

    event.preventDefault();

    const group = event.currentTarget.closest('[role="radiogroup"]');
    const segments = Array.from(group?.querySelectorAll<HTMLButtonElement>('[role="radio"]') ?? []);
    const currentIndex = segments.indexOf(event.currentTarget);
    const nextIndex = (currentIndex + 1) % segments.length;

    segments[nextIndex]?.focus();
    segments[nextIndex]?.click();
  }

  return (
    <div
      className="header-language-toggle"
      role="radiogroup"
      aria-label={intl.formatMessage({
        id: 'gritx.common.header.language',
        defaultMessage: 'Language'
      })}
    >
      <span
        className={cn('header-language-toggle__thumb', {
          'header-language-toggle__thumb--en': isEnglish
        })}
      />
      <button
        type="button"
        role="radio"
        aria-checked={!isEnglish}
        className={cn('header-language-toggle__segment', {
          'header-language-toggle__segment--active': !isEnglish
        })}
        onClick={handleSelect(SystemLanguage.Spanish)}
        onKeyDown={handleSegmentKeyDown}
      >
        <span className="header-language-toggle__label--abbr">ES</span>
        <span className="header-language-toggle__label--full">Español</span>
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={isEnglish}
        className={cn('header-language-toggle__segment', {
          'header-language-toggle__segment--active': isEnglish
        })}
        onClick={handleSelect(SystemLanguage.English)}
        onKeyDown={handleSegmentKeyDown}
      >
        <span className="header-language-toggle__label--abbr">EN</span>
        <span className="header-language-toggle__label--full">English</span>
      </button>
    </div>
  );
};
